export default {"src":"/_next/static/media/trash_delete_icon.81b54e5d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};